import { getTvObject, tv } from '@costar-ui/cosmos';

var textDividerTvObject = getTvObject({
  base: ['mx-auto', 'my-0', 'border-t', 'text-center', 'w-3/4'],
  variants: {
    light: {
      "true": ['border-neutral/50'],
      "false": ['border-neutral']
    }
  }
});
var textDividerStyles = tv(textDividerTvObject);

export { textDividerStyles, textDividerTvObject };
//# sourceMappingURL=text-divider.styles.esm.js.map
